import api from './Api'


const defalutGetFeedCommentAdminByFeedCommentIdQuery = 'id nickName content createdDate feedCommentHiddenId isHidden feedId category'
export const getFeedCommentAdminByFeedCommentId = <T>(feedCommentId: number, responseQuery: string = defalutGetFeedCommentAdminByFeedCommentIdQuery) => {
    const query = `query getFeedCommentAdminByFeedCommentId($feedCommentId:ID!) { getFeedCommentAdminByFeedCommentId(feedCommentId:$feedCommentId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getFeedCommentAdminByFeedCommentId: T }>>('/graphql', { query, variables: { feedCommentId } })
}


const defalutGetAllFeedCommentAdminQuery = 'id nickName content createdDate feedCommentHiddenId isHidden feedId'
export const getAllFeedCommentAdmin = <T>(responseQuery: string = defalutGetAllFeedCommentAdminQuery) => {
    const query = `query getAllFeedCommentAdmin { getAllFeedCommentAdmin { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getAllFeedCommentAdmin: T }>>('/graphql', { query })
}

const defalutGetAllFeedCommentAdminByFeedIdQuery = 'id nickName content createdDate feedMemoHiddenId isHidden feedId'
export const getAllFeedCommentAdminByFeedId = <T>(feedId: number, responseQuery: string = defalutGetAllFeedCommentAdminByFeedIdQuery) => {
    const query = `query getAllFeedCommentAdminByFeedId($feedId:ID!) { getAllFeedCommentAdminByFeedId(feedId:$feedId) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getAllFeedCommentAdminByFeedId: T }>>('/graphql', { query, variables: { feedId } })
}